import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Ahmed Hassan',
  location: 'Karachi',
  rating: 5,
  comment: 'Excellent service and genuine products! My AirPods Pro arrived within 2 days. Will definitely order again.',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100',
  product: 'Apple AirPods Pro'
}, {
  id: 2,
  name: 'Fatima Khan',
  location: 'Lahore',
  rating: 5,
  comment: 'Best prices in Pakistan! The customer support team was very helpful in choosing the right smartwatch for me.',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100',
  product: 'Apple Watch Series 9'
}, {
  id: 3,
  name: 'Muhammad Ali',
  location: 'Islamabad',
  rating: 5,
  comment: 'Fast delivery and secure packaging. The gaming mouse works perfectly. Highly recommended!',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100',
  product: 'Logitech G502 HERO'
}, {
  id: 4,
  name: 'Sara Ahmed',
  location: 'Rawalpindi',
  rating: 5,
  comment: 'Amazing quality products at affordable prices. The power bank has been a lifesaver during travel.',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100',
  product: 'Xiaomi Power Bank'
}];
export function TestimonialsSection() {
  return <section className="py-12 bg-gray-50" aria-labelledby="testimonials-heading" data-id="element-257" data-mp="1aj3snxriihz9">
      <div className="max-w-7xl mx-auto px-4" data-id="element-258" data-mp="1oa8un6icrmcr">
        <div className="text-center mb-10" data-id="element-259" data-mp="1odd34g2up498">
          <h2 id="testimonials-heading" className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-260" data-mp="1kaggmea6wo00">
            What Our Customers Say
          </h2>
          <p className="text-gray-600" data-id="element-261" data-mp="1y7dg144djdsi">
            Join thousands of satisfied customers across Pakistan
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-262" data-mp="3ux5vs8gjfid">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-white rounded-xl p-6 shadow-card hover:shadow-card-hover transition-shadow duration-300" data-id="element-263" data-mp="3v2jbhqeqls1v">
              <QuoteIcon className="w-8 h-8 text-primary-200 mb-4" data-id="element-264" data-mp="1z0oempz9u1tq" />

              <div className="flex items-center gap-1 mb-3" data-id="element-265" data-mp="23yhi3b96whqb">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-4 h-4 ${i < testimonial.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-266" data-mp="27y8fhxt81w3t" data-mpi={i} />)}
              </div>

              <p className="text-gray-600 text-sm mb-4 line-clamp-4" data-id="element-267" data-mp="2hxh6chssiuly">
                "{testimonial.comment}"
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-gray-100" data-id="element-268" data-mp="2mvr2aumc9z8m">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-10 h-10 rounded-full object-cover" data-id="element-269" data-mp="2rmr0s4b3wpd8" />
                <div data-id="element-270" data-mp="2vnt2crshxdid">
                  <p className="font-medium text-gray-900 text-sm" data-id="element-271" data-mp="2vocgryixtjrn">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-272" data-mp="30m4dr6yfvw2p">
                    {testimonial.location}
                  </p>
                </div>
              </div>

              <p className="mt-3 text-xs text-primary-600 font-medium" data-id="element-273" data-mp="3fsjtv1cd3tz8">
                Purchased: {testimonial.product}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}